import React, { forwardRef } from 'react';
import * as S from './style';

type CardProperties = React.HtmlHTMLAttributes<HTMLDivElement>;

const Card = forwardRef<any, CardProperties>((properties, reference) => (
  <S.Card {...properties} ref={reference} />
));

Card.displayName = 'Card';

export default Card;
